<script lang="ts">
import { defineComponent } from "vue";
import { computed, ref } from "vue";

export default defineComponent({
  name: "ContactSticky",
  props: {
    isMakler: {
      type: Boolean,
      default: false,
    },
    positionX: { type: Number, default: 0 },
    positionY: { type: Number, default: 0 },
    sticky: { type: Boolean, default: true },
  },
  setup(props) {
    const isTelefonAktiv = ref(true);
    const isMailAktiv = ref(false);

    function toggle_telefon() {
      isTelefonAktiv.value = !isTelefonAktiv.value;
      if (isTelefonAktiv.value) {
        isMailAktiv.value = false;
      }
    }

    function toggle_mail() {
      isMailAktiv.value = !isMailAktiv.value;
      if (isMailAktiv.value) {
        isTelefonAktiv.value = false;
      }
    }

    const telefonNummer = computed(() => {
      return props.isMakler ? "040 37663-222" : "040 37663-366";
    });

    const emailAdresse = computed(() => {
      return props.isMakler ? "maklerservice@grundvers.de" : "kundenservice@grundvers.de";
    });

    return {
      props,
      isTelefonAktiv,
      isMailAktiv,
      toggle_telefon,
      toggle_mail,
      telefonNummer,
      emailAdresse,
    };
  },
});
</script>

<template>
  <div
    class="kontakt_container"
    :class="{ fixiert: sticky }"
    style="width: 1140px; margin-left: calc((100vw - 1140px) / 2)"
  >
    <div class="kontaktArt_container">
      <div class="content_container" :class="{ aktiv: isTelefonAktiv }">
        <span @click="toggle_telefon" class="contact-icon contact-icon_telefon" :class="{ links: isTelefonAktiv }"
          >&nbsp;</span
        >
        <span class="contact-text" :class="{ offen: isTelefonAktiv }">
          <a tabindex="-1"  :href="'tel:' + telefonNummer"> {{ telefonNummer }}</a>
        </span>
      </div>
      <div class="content_container" :class="{ aktiv: isMailAktiv }">
        <span @click="toggle_mail" class="contact-icon contact-icon_mail" :class="{ links: isMailAktiv }">&nbsp;</span>
        <span class="contact-text" :class="{ offen: isMailAktiv }">
          <a tabindex="-1" :href="'mailto:' + emailAdresse"> {{ emailAdresse }}</a>
        </span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.kontakt_container {
  margin: 0 0 -60px;
  padding: 0;
  overflow: hidden !important;
  top: v-bind(positionY);
  right: v-bind(positionX);
  z-index: 99;
  pointer-events: none;
}

.kontaktArt_container {
  float: right;
  font-size: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.content_container {
  width: 240px;
  overflow: hidden;
  pointer-events: auto;
}

.contact-icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  flex-grow: 2;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #0f5582;
  cursor: pointer;
  vertical-align: top;
  float: right;
}

.contact-text {
  height: 30px;
  display: none;
  background-color: #0f5582;
  text-align: center;
}

.offen {
  display: inline-block;
}

.links {
  float: right;
}

.contact-text a {
  color: #ffffff;
  text-decoration: none;
  display: inline-block;
  // width: 210px;
  padding-top: 4px;
  padding-right: 10px;
  padding-left: 10px;
}

.aktiv {
  text-align: right;
  // width: 240px;
}

.fixiert {
  position: sticky;
}

@media (max-width: 768px) {
  .kontakt_container {
    display: none;
  }
}
</style>
